/* Beebizco – bundle / "Complete the look". Adds every ticked item to the basket in one request. */
if (!customElements.get('bbz-bundle')) {
  customElements.define('bbz-bundle', class BbzBundle extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse(this.querySelector('[data-variants]').textContent); } catch (e) { return; }
      this.items = Array.from(this.querySelectorAll('[data-item]'));
      this.button = this.querySelector('[data-add]');
      this.totalEl = this.querySelector('[data-total]');
      this.errorEl = this.querySelector('[data-error]');
      this.tierEl = this.querySelector('[data-tier]');
      this.afterEl = this.querySelector('[data-after]');
      this.noteEl = this.querySelector('[data-tier-note]');
      try { this.phases = JSON.parse(this.querySelector('[data-phases]').textContent); } catch (e) { this.phases = []; }
      this.cartSubtotal = 0;
      this.bundleTotal = 0;
      this.loadCart();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.loadCart());
      }
      this.addEventListener('change', () => this.update());
      this.button.addEventListener('click', () => this.add());
      if (this.querySelector('[data-current]') && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          const v = e && e.data && e.data.variant;
          if (v) { this.matchSize(v.options); this.update(); }
        });
      }
      const cv = this.currentVariant();
      if (cv) this.matchSize(cv.options);
      this.update();
    }
    disconnectedCallback() { if (this.unsub) this.unsub(); if (this.unsubCart) this.unsubCart(); }
    loadCart() {
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((c) => { this.cartSubtotal = c.items_subtotal_price || 0; this.renderTier(); })
        .catch(() => {});
    }
    activePhase() {
      const now = Date.now();
      return this.phases.find((p) => (!p.start || now >= Date.parse(p.start)) && (!p.end || now < Date.parse(p.end))) || null;
    }
    /* Shows what the spend tiers mean for this set, counting what is already in the basket. */
    renderTier() {
      if (!this.tierEl) return;
      const phase = this.activePhase();
      const set = this.bundleTotal;
      this.afterEl.hidden = true;
      this.noteEl.hidden = true;
      if (!phase || !set) { this.tierEl.textContent = ''; return; }
      const tiers = phase.tiers.slice().sort((a, b) => a.min - b.min);
      const spend = this.cartSubtotal + set;
      let got = null; let next = null;
      tiers.forEach((t) => { if (spend >= t.min) got = t; else if (!next) next = t; });
      const inBasket = this.cartSubtotal > 0 ? ' with what\'s already in your basket' : '';
      const label = phase.label ? phase.label + ': ' : '';
      let html = '';
      if (got) {
        const save = Math.round(set * got.pct / 100);
        this.afterEl.textContent = this.money(set - save) + ' after ' + got.pct + '% off';
        this.afterEl.hidden = false;
        html = label + '<strong>' + got.pct + '% off</strong> comes off at checkout' + inBasket + '.';
        if (next) html += ' Add <strong>' + this.money(next.min - spend) + '</strong> more for <strong>' + next.pct + '% off</strong>.';
      } else if (next) {
        html = label + 'Add <strong>' + this.money(next.min - spend) + '</strong> more to get <strong>' + next.pct + '% off</strong> at checkout.';
      }
      this.tierEl.innerHTML = html;
      if (phase.note) { this.noteEl.textContent = phase.note; this.noteEl.hidden = false; }
    }
    money(c) { const p = c / 100; return '£' + (c % 100 === 0 ? p.toFixed(0) : p.toFixed(2)); }
    product(li) { return this.data[li.dataset.item]; }
    currentVariant() {
      const li = this.querySelector('[data-current]');
      if (!li) return null;
      const section = this.closest('.shopify-section') || document;
      const input = section.querySelector('.product-variant-id') || section.querySelector('form[action*="/cart/add"] input[name="id"]');
      const id = input ? Number(input.value) : NaN;
      return this.product(li).variants.find((v) => v.id === id) || null;
    }
    variantFor(li) {
      if (li.hasAttribute('data-current')) return this.currentVariant();
      const p = this.product(li);
      const sels = Array.from(li.querySelectorAll('select'));
      if (!sels.length) return p.variants[0];
      const vals = sels.map((s) => s.value);
      return p.variants.find((v) => vals.every((val, i) => v.options[i] === val)) || null;
    }
    sizeIndex(options) { return options.findIndex((o) => /size/i.test(o)); }
    /* Pre-select the same size in the other items, keeping their colour where that size is in stock. */
    matchSize(currentOptions) {
      const cur = this.querySelector('[data-current]');
      if (!cur || !currentOptions) return;
      const ci = this.sizeIndex(this.product(cur).options);
      if (ci < 0) return;
      const size = String(currentOptions[ci]).toLowerCase();
      this.items.forEach((li) => {
        if (li === cur) return;
        const p = this.product(li);
        const si = this.sizeIndex(p.options);
        if (si < 0) return;
        const sels = Array.from(li.querySelectorAll('select'));
        const sizeSel = sels[si];
        if (!sizeSel) return;
        const match = Array.from(sizeSel.options).find((o) => o.value.toLowerCase() === size || o.value.toLowerCase().split(' ')[0] === size);
        if (!match) return;
        const keep = sels.map((s) => s.value);
        keep[si] = match.value;
        let v = p.variants.find((x) => x.available && keep.every((val, i) => x.options[i] === val));
        if (!v) v = p.variants.find((x) => x.available && x.options[si] === match.value);
        if (v) sels.forEach((s, i) => { s.value = v.options[i]; });
      });
    }
    update() {
      let total = 0; let n = 0;
      this.items.forEach((li) => {
        const on = li.querySelector('[data-include]').checked;
        li.classList.toggle('is-off', !on);
        const v = this.variantFor(li);
        const status = li.querySelector('[data-status]');
        if (v) li.querySelector('[data-price]').textContent = this.money(v.price);
        status.textContent = v && v.available ? '' : (li.hasAttribute('data-current') ? 'Choose an in-stock size above' : 'Out of stock in that colour and size');
        if (on && v && v.available) { total += v.price; n += 1; }
      });
      this.totalEl.textContent = this.money(total);
      this.bundleTotal = total;
      this.renderTier();
      this.button.textContent = n > 1 ? 'Add all ' + n + ' to basket' : (n === 1 ? 'Add to basket' : 'Choose items');
      this.button.disabled = n === 0;
      this.errorEl.hidden = true;
    }
    async add() {
      const items = []; let blocked = false;
      this.items.forEach((li) => {
        if (!li.querySelector('[data-include]').checked) return;
        const v = this.variantFor(li);
        if (!v || !v.available) { blocked = true; return; }
        items.push({ id: v.id, quantity: 1 });
      });
      if (blocked) { this.showError('One of the items is out of stock in the colour or size chosen. Change it or untick it.'); return; }
      if (!items.length) return;
      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      this.button.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok || data.status) { this.showError(data.description || data.message || 'Sorry, that could not be added. Please try again.'); return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bbz-bundle', cartData: data });
        if (drawer && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
        else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
      } catch (e) {
        this.showError('Sorry, that could not be added. Please try again.');
      } finally {
        this.button.removeAttribute('aria-busy');
      }
    }
    showError(msg) { this.errorEl.textContent = msg; this.errorEl.hidden = false; }
  });
}
